import { XML_CreateTriPath } from "./XML_CreateTriPath";

export function XML_CreateTriPath2(sx, sy, ex, ey, drawElement) {
  drawElement.CreateTriPath2(sx, sy, ex, ey);
}
